function clickTranslateButtonIfNotClicked(btn) {
    if (btn.dataset.clicked !== "true") {
        btn.click();
        btn.dataset.clicked = "true";
    }
}

function addClickHandlerToLoadMore(loadMore) {
    if (loadMore.dataset.listenerAttached === "true") return;

    loadMore.addEventListener("click", () => {
        // Optional fallback in case MutationObserver misses something
        setTimeout(() => {
            document
                .querySelectorAll(".jdgm-translate-button")
                .forEach(clickTranslateButtonIfNotClicked);
        }, 1000);
    });

    loadMore.dataset.listenerAttached = "true";
}

function processNewNodes(nodes) {
    nodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // If the node is a Load More button
        if (node.matches(".jdgm-paginate__load-more")) {
            addClickHandlerToLoadMore(node);
        } else if (node.querySelectorAll) {
            node.querySelectorAll(".jdgm-paginate__load-more").forEach(addClickHandlerToLoadMore);
        }

        // If the node is a Translate button
        if (node.matches(".jdgm-translate-button")) {
            clickTranslateButtonIfNotClicked(node);
        } else if (node.querySelectorAll) {
            node.querySelectorAll(".jdgm-translate-button").forEach(clickTranslateButtonIfNotClicked);
        }
    });
}

// Set up MutationObserver
const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => processNewNodes([...mutation.addedNodes]));
});

document.addEventListener("DOMContentLoaded", () => {
    if (document.documentElement.lang !== "en") return;

    // Initial pass: translate and bind Load More buttons
    document
        .querySelectorAll(".jdgm-translate-button")
        .forEach(clickTranslateButtonIfNotClicked);

    document
        .querySelectorAll(".jdgm-paginate__load-more")
        .forEach(addClickHandlerToLoadMore);

    const reviewsContainer = document.querySelector(".jdgm-rev-widg");
    if (reviewsContainer) {
        observer.observe(reviewsContainer, { childList: true, subtree: true });
    }
});
